// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__wEiyK","heading--mobile":"Heading_heading--mobile__JB-Ma"};